import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MbpButtonComponent, MbpButtonType } from '@components/form';

@Component({
  selector: 'mbp-message-with-action',
  templateUrl: './mbp-message-with-action.component.html',
  styleUrl: './mbp-message-with-action.component.scss',
  imports: [TranslateModule, MbpButtonComponent]
})
export class MbpMessageWithActionComponent {
  icon = input.required<string>();
  titleKey = input.required<string>();
  messageKey = input.required<string>();
  actionTextKey = input.required<string>();
  actionSvg = input<string | undefined>(undefined);
  actionType = input<MbpButtonType>('primary');
  actionDisabled = input<boolean>(false);

  action = output<void>();

  protected onAction(): void {
    this.action.emit();
  }
}
